<!--FastBI产品-->
<template>
  <div class="home-main xz_products clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">小智开发者平台</span> <span class="title-en">/XZ Developer Platform</span>
        <div class="main-title-right" v-loading="loading">
          <el-button size="medium" class="danger" @click="triallDialogOpen">产品试用</el-button>
          <el-button size="medium" class="primary" @click="buyFirstDialogOpen">申请购买</el-button>
        </div>
      </div>
      <!--筛选部分start-->
      <div class="product-selector">
        <div class="selector-left">
          <div class="block">
            <span class="demonstration">开通时间</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateStart" type="date" align="right"
              :picker-options="pickerOptions1" size="small">
            </el-date-picker>
          </div>
          <div class="block">
            <span class="demonstration">到</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateEnd" type="date" align="right"
              :picker-options="pickerOptions2" size="small">
            </el-date-picker>
          </div>
          <div class="block">
            <span class="demonstration">过期时间</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.expirationDateStart" type="date"
              align="right" :picker-options="pickerOptions3" size="small">
            </el-date-picker>
          </div>
          <div class="block">
            <span class="demonstration">到</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.expirationDateEnd" type="date" align="right"
              :picker-options="pickerOptions4" size="small">
            </el-date-picker>
          </div>
        </div>
        <div class="selector-center"
          :style="isMaintainer() ? 'margin-left: 0px !important; width: 250px !important;' : ''">
          <div class="demo-input-suffix1">
            <p>授权客户名称</p>
            <el-input :style="isMaintainer() ? 'width: 150px !important;' : ''" v-model="searchOption.customerName"
              size="small" clearable></el-input>
          </div>
          <!-- <div class="demo-input-suffix">
            <p>授权IP/域名</p>
            <el-input v-model="searchOption.domain" size="small" clearable></el-input>
          </div> -->
        </div>
        <div class="selector-center" v-if="isMaintainer()"
          :style="isMaintainer() ? 'margin-left: 0px !important; width: 250px !important;' : ''">
          <div class="demo-input-suffix1">
            <p>伙伴用户名</p>
            <el-input :style="isMaintainer() ? 'width: 150px !important;' : ''" v-model="searchOption.username"
              size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-right">
          <el-button size="small" :style="isMaintainer() ? 'margin-left: 50px;' : ''" class="warning"
            @click="search">搜索</el-button>
          <el-button size="small" @click="restSearch">重置</el-button>
        </div>
      </div>
      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-table :data="tableData" height="100%" style="width: 100%" stripe>
          <el-table-column width="20"> </el-table-column>
          <!-- <el-table-column label="产品系列">
            <template slot-scope="scope">
              <span>{{ parseSeriesName(scope.row.edition) }}</span>
            </template>
</el-table-column> -->
          <!-- <el-table-column label="产品版本">
            <template slot-scope="scope">
              <span>{{ parseVersion(scope.row.grade) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权许可数">
            <template slot-scope="scope">
              <span>{{ scope.row.user_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权模块">
            <template slot-scope="scope">
              <span>{{ scope.row.modules_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权客户名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.user_company }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="授权用户数">
            <template slot-scope="scope">
              <span>{{ scope.row.user_count }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.user_company }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开通时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="过期时间">
            <template slot-scope="scope">
              <span>{{ parseDate(scope.row.expire_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ getAuthStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" class="table-status">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 3">
                <!-- v-if="isShowDelayBtn(scope.$index, scope.row)" -->
                <el-button size="mini" type="primary" @click="delayClick(scope.$index, scope.row)">延期</el-button>
              </span>
              <span v-if="scope.row.expire_time != '买断'">
                <el-button size="mini" type="primary" @click="renewOrBuy(scope.$index, scope.row)">购买</el-button>
              </span>
              <el-button size="mini" type="primary" @click="addmoduleOpen(scope.$index, scope.row)">增购模块</el-button>
              <el-button size="mini" type="primary" @click="addUserOpen(scope.$index, scope.row)">增购许可</el-button>

              <el-button size="mini" type="success" @click="editCustomerOpen(scope.$index, scope.row)">编辑信息</el-button>
              <el-button size="mini" v-if="scope.row.status === 0" type="success"
                @click="upgradeHanlde(scope.$index, scope.row)">升级</el-button>
              <el-button size="mini" v-if="is_superuser" type="primary"
                @click="authorizationTransfer(scope.$index, scope.row)">授权转移</el-button>
              <el-button v-if="scope.row.status === 3 && is_superuser" size="mini" type="primary"
                @click="trialExtension(scope.$index, scope.row)">试用延期</el-button>
              <!-- <el-button
                size="mini"
                type="primary"
                @click="certificateOpen(scope.$index, scope.row)"
                >授权证书</el-button
              > -->
              <!-- <el-button
                size="mini"
                type="primary"
                @click="offlineAuthOpen(scope.$index, scope.row)"
                >离线授权</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
      <!--产品列表end-->

      <!--产品加点弹窗start-->
      <el-dialog :before-close="restAddPointForm" title="FastBI产品加点" :visible.sync="addPointDialog" width="600px"
        class="addPointDialog">
        <el-form v-if="!payTableShow" ref="addPointForm" :model="addPointForm" :rules="addPointFormRules">
          <el-form-item label="授权码" :label-width="formLabelWidth">
            <el-input v-model="addPointForm.code" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="授权客户名称" :label-width="formLabelWidth">
            <el-input v-model="addPointForm.name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="已购买用户数" :label-width="formLabelWidth">
            <el-input v-model="addPointForm.old_user_count" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="新增用户数" prop="user_count" :label-width="formLabelWidth">
            <el-input v-model.number="addPointForm.user_count" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-radio-group v-model="addPointForm.pay_type">
              <el-radio :label="0">专用币</el-radio>
              <el-radio :label="1">小智专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
        <div v-if="payTableShow" class="clearfix">
          <el-table :data="payTableData" border style="width: 100%">
            <el-table-column prop="code" label="授权码" width="180"> </el-table-column>
            <el-table-column prop="user_count" label="用户数" width="80"> </el-table-column>
            <el-table-column prop="months" label="购买时长">
              <template slot-scope="scope">
                <span>{{ scope.row.months }}个月</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
          </el-table>
          <el-alert class="alert" title="支付描述" :type="alertType" :closable="false" :description="payDescription">
          </el-alert>
          <el-button v-if="payBtnShow" class="primary pay_btn" @click="addPointPay">确认支付</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!payTableShow">
          <el-button @click="cancel('addPointForm', (addPointDialog = false))">取 消</el-button>
          <el-button class="primary" @click="addPointSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!--产品加点弹窗end-->

      <!--产品续费弹窗start-->
      <el-dialog :before-close="restRenewForm" title="FastBI产品续费" :visible.sync="renewDialog" width="506px"
        class="renewDialog">
        <el-form v-if="!payTableShow" ref="renewForm" :rules="renewFormRules" :model="renewForm">
          <el-form-item label="授权码" :label-width="formLabelWidth">
            <el-input v-model="renewForm.code" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="授权客户名称" :label-width="formLabelWidth">
            <el-input v-model="renewForm.name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="已购买用户数" :label-width="formLabelWidth">
            <el-input
              v-model="renewForm.old_user_count"
              autocomplete="off"
              :disabled="true"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="当前授权有效期至" :label-width="formLabelWidth">
            <el-input v-model="renewForm.old_expire_time" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-if="
            currentEdition == 'FastBI企业版' || currentEdition == 'FastBI高级版' || currentEdition == 'FastBI基础版'
          " label="续费时长" :label-width="formLabelWidth">
            <el-select v-model="renewForm.months" placeholder="请选择" @change="getExpireTime">
              <el-option :label="'买断'" :value="10000"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="续费时长" :label-width="formLabelWidth">
            <el-select v-model="renewForm.months" placeholder="请选择" @change="getExpireTime">
              <el-option v-for="item in buyDate" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="续费后有效期至" :label-width="formLabelWidth">
            <span>{{ renewForm.buy_expire_time }}</span>
          </el-form-item>
          <!-- <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-radio-group v-model="renewForm.pay_type">
              <el-radio :label="0">专用币</el-radio>
              <el-radio :label="1">小智专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
        <div v-if="payTableShow" class="clearfix">
          <el-table :data="payTableData" border style="width: 100%">
            <el-table-column prop="code" label="授权码" width="180"> </el-table-column>
            <el-table-column prop="user_count" label="用户数" width="80"> </el-table-column>
            <el-table-column prop="months" label="购买时长">
              <template slot-scope="scope">
                <span>{{ scope.row.months }}个月</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
          </el-table>
          <el-alert class="alert" title="支付描述" :type="alertType" :closable="false" :description="payDescription">
          </el-alert>
          <el-button v-if="payBtnShow" class="primary pay_btn" @click="renewPay">确认支付</el-button>
        </div>
        <div v-if="!payTableShow" slot="footer" class="dialog-footer">
          <el-button @click="cancel('renewForm', (renewDialog = false))">取 消</el-button>
          <el-button class="primary" @click="renewSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!--产品续费弹窗end-->

      <!--产品修改密码弹窗start-->
      <el-dialog :before-close="restChangeKeyForm" title="FastBI产品修改密码" :visible.sync="changeKeyDialog" width="506px"
        class="changeKeyDialog">
        <el-form :model="changKeyForm" ref="changKeyForm" :rules="changKeyFormRules">
          <el-form-item label="授权码" :label-width="formLabelWidth">
            <el-input v-model="changKeyForm.code" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
            <el-input type="password" v-model="changKeyForm.newPassword" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="rePassword" :label-width="formLabelWidth">
            <el-input type="password" v-model="changKeyForm.rePassword" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('changKeyForm', (changeKeyDialog = false))">取 消</el-button>
          <el-button class="primary" @click="changeKeySubmit">保 存</el-button>
        </div>
      </el-dialog>
      <!--产品修改密码弹窗end-->

      <!--编辑授权账号信息start-->
      <el-dialog :before-close="restEditCustomerForm" title="编辑授权账号信息" :visible.sync="editCustomerDialog" width="510px"
        class="editCustomerDialog">
        <el-form :model="editCustomerForm" ref="editCustomerForm" :rules="editCustomerFormRules">
          <el-form-item label="授权客户名称" prop="name" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="客户联系人" prop="contact_name" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.contact_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="phone" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系人邮箱" prop="email" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('editCustomerForm', (editCustomerDialog = false))">取 消</el-button>
          <el-button class="primary" @click="editCustomerSubmit">保 存</el-button>
        </div>
      </el-dialog>
      <!--编辑授权账号信息end-->

      <!--授权证书start-->
      <el-dialog title="授权证书" :visible.sync="certificateDialog" width="810px" class="editCustomerDialog">
        <div class="certificate_img_main">
          <img :src="certificateUrl" style="padding-right:10px" alt="" width="50%" />
          <img :src="certi_attach_url" alt="" width="50%" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="primary" @click="certificateDialog = false">关闭</el-button>
        </div>
      </el-dialog>
      <!--授权证书end-->
      <!-- 离线授权 -->
      <el-dialog title="离线授权" :visible.sync="offlineDialog" width="510px" class="editCustomerDialog">
        <!-- <img :src="certificateUrl" alt="" width="100%" /> -->
        <el-form ref="form" :model="offlineForm" label-width="80px">
          <el-form-item label="授权码">
            <!-- <el-input v-model="offlineForm.code"></el-input> -->
            {{ offlineForm.auth_code }}
          </el-form-item>
          <el-form-item label="机器码"> <el-input v-model="offlineForm.code"></el-input> </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="primary" @click="applyOffline">确定</el-button>
          <el-button class="primary" @click="offlineAuthClose">关闭</el-button>
        </div>
      </el-dialog>
    </div>

    <buyApiDialog ref="buyApiDialog"></buyApiDialog>
    <upgradeDialog ref="upgradeDialog"></upgradeDialog>
    <transferDialog ref="transferDialog"></transferDialog>
    <extensionDialog ref="extensionDialog"></extensionDialog>
    <addApiProduct ref="addApiProduct"></addApiProduct>
  </div>
</template>

<script>
import buyApiDialog from './buyApiProduct.vue';
import upgradeDialog from './upgradeDialog.vue';
import addApiProduct from './addApiProduct.vue';
import transferDialog from '../product/dialog/transferDialog.vue';
import extensionDialog from '../product/dialog/extensionDialog.vue';
import { isvalidPhone } from '@/assets/js/validate';
import { getAuthBySearch, getAuthByProduct, getProductEditions, getXZEditions } from '@/api/auth';
import {
  getXZAuthList,
  buyXZ,
  addXZMonth,
  addXZMonthPrice,
  buyXZPrice,
  trailXZ,
  trialXZDelay,
  getXZLicense,
  getXZModuleList,
  updateXZAuth,
} from '@/api/xzr_auth';
import { createGetUrlParams } from '@/utils/url';
import { authStatus, edition } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { seriesName, version } from './utils';
export default {
  data() {
    //手机号验证
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!isvalidPhone(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };
    //两次密码是否相等
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changKeyForm.newPassword) {
        callback(new Error('两次输入密码请保持一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      offlineDialog: false, //离线授权
      fastbiEditions: [],
      currentEdition: '',
      meEdition: edition[1],
      verifyCodeResult: {
        //接收效验code是否已存在结果
        success: false,
        loading: false,
        icon: '',
      },
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      codeLoading: false,
      curentId: 0, //选中表格行的id
      currentIndex: 0, //选中表格行的元素下标
      payTableShow: false,
      payTableData: [], //支付所需价格表
      payData: '', //需要支付的数据
      payBtnShow: false,
      alertType: 'success',
      payDescription: '',
      /*筛选条件*/
      searchOption: {
        openingDateStart: '', //选择开通时间-开始
        openingDateEnd: '', //选择开通时间-结束
        expirationDateStart: '', //选择过期时间-开始
        expirationDateEnd: '', //选择过期时间-结束
        customerName: '', //选择授权客户
        code: '', //选择授权码
        username: ""
      },

      /*开通时间start*/
      pickerOptions1: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近90天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近1年',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*开通时间end*/

      /*过期时间start*/
      pickerOptions3: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions4: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '30天后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*过期时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/

      formLabelWidth: '125px',
      editionDict: {
        1: '小智报表高级版',
        101: '小智BI高级版',
      },
      /*产品试用start*/
      triallDialog: false,
      FBITriallDateValue: '',
      triallForm: {
        code: '', //试用产品授权码
        key: '', //试用产品授权密码
        name: '', //试用产品公司名称
        contact_name: '', //试用产品联系人
        //user_count: 1,
        phone: '', //试用产品联系电话
        email: '', //试用产品联系邮箱
        trail_days: 30,
        fbi_edition: 1,
      },
      triallFormRules: {
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        user_count: [{ type: 'number', message: '请输入数字' }],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      triallDate: [
        {
          value: 7,
          label: '七天',
        },
        {
          value: 15,
          label: '十五天',
        },
        {
          value: 30,
          label: '一个月',
        },
      ],
      /*产品试用end*/

      /*申请购买产品start*/
      buyFirstDialog: false,
      buyFirstForm: {
        code: '', //产品授权码
        key: '', //产品授权密码
        name: '', //授权客户名称
        contact_name: '', //客户联系人
        phone: '', //联系人手机
        email: '', //联系人邮箱
        user_count: 1, //购买用户数,
        months: 12,
        product: 1,
        edition: '11',
        pay_type: 1,
      },
      buyFirstFormRules: {
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
        user_count: [{ type: 'number', message: '请输入数字' }],
      },
      buyDate: [
        {
          value: 12,
          label: '一年',
        },
        {
          value: 24,
          label: '两年',
        },
        {
          value: 36,
          label: '三年',
        },
        {
          value: 10000,
          label: '买断',
        },
      ],
      buyDateDict: {
        12: 1,
        24: 2,
        36: 3,
        10000: '买断',
      },
      /*申请购买产品end*/

      /*产品加点start*/
      addPointDialog: false,
      addFastBIDateValue: '',
      addPointForm: {
        code: '', //产品授权码
        key: '', //产品授权密码
        name: '', //授权客户名称
        old_user_count: '', //已购买用户数
        user_count: 1, //新增用户数
        pay_type: 1,
      },
      addPointFormRules: {
        user_count: [
          { required: true, message: '请输入新增用户数', trigger: 'blur' },
          { type: 'number', message: '请输入数字' },
        ],
      },
      /*产品加点end*/

      /*产品续费start*/
      renewDialog: false,
      renewForm: {
        code: '', //产品授权码
        name: '', //授权客户名称
        old_user_count: '', //已购买用户数
        pay_type: 1,
        months: 12,
        old_expire_time: '', // 过期时间
        buy_expire_time: '',
      },
      renewFormRules: {
        months: [
          { required: true, message: '请输入新增用户数', trigger: 'blur' },
          { type: 'number', message: '请输入数字' },
        ],
      },
      /*产品续费end*/

      /*产品修改密码start*/
      changeKeyDialog: false,
      changeFastBIDateValue: '',
      changKeyForm: {
        code: '', //产品授权码
        newPassword: '', //新密码
        rePassword: '', //确认密码
      },
      changKeyFormRules: {
        newPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        rePassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
      },
      /*产品修改密码end*/

      /*编辑授权账号信息start*/
      editCustomerDialog: false,
      editFastBIDateValue: '',
      editCustomerForm: {
        name: '', //授权客户名称
        contact_name: '', //客户联系人
        phone: '', //联系人手机
        email: '', //联系人邮箱
      },
      editCustomerFormRules: {
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        phone: [],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      /*编辑授权账号信息end*/
      /*显示授权证书 start*/
      certificateDialog: false,
      certificateUrl: '',
      certi_attach_url: '',
      /*显示授权证书 end*/
      offlineForm: {
        code: '',
        auth_code: '',
      },
      XZEditions: [],
      is_superuser: false,
      n_module:{}
    };
  },
  created() {
    this.initXZEditions();
  },
  mounted() {
    getXZModuleList().then(res => {
      this.n_module = {
        "api_base":"小智API-标准"
      }
      res.map(item=>{
        this.n_module[item.code] = item.name;
      })
      // this.n_module = [{
      //   value: "api_base",
      //   name: "小智API-标准",
      //   dependency: ""
      // }].concat(res.map(item => {
      //   return {
      //     value: item.code,
      //     name: item.name,
      //     dependency: item.code == "api_pro" ? "api_base" : item.dependency
      //   }
      // }))
      this.getAuthData();
      this.getUserInfo();
    });

  },
  methods: {
    async getUserInfo() {
      const res = await this.$store.dispatch('user/userinfo');
      this.is_superuser = res.is_superuser;
    },
    /* 授权转移 */
    authorizationTransfer(index, row) {
      this.$refs.transferDialog.show();
      this.$refs.transferDialog.initData(row, 'xz');
    },
    /* 试用延期 */
    trialExtension(index, row) {
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, 'xz');
    },
    parseSeriesName(edition) {
      return seriesName[edition];
    },
    parseVersion(grade) {
      return version[grade];
    },
    // 离线授权
    offlineAuth() { },
    getFastBIEditions() {
      this.loading = true;
      getProductEditions()
        .then((res) => {
          this.fastbiEditions = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    triallChange(val) {
      if (val == 11) {
        //标准版
        this.triallForm.user_count = 1;
      } else if (val == 12) {
        //高级版
        this.triallForm.user_count = 100;
      }
    },
    changeEdition(val) {
      if (val == 11) {
        //标准版
        this.buyFirstForm.user_count = 1;
        this.buyFirstForm.months = 12;
      } else if (val == 12) {
        //高级版
        this.buyFirstForm.user_count = 100;
        this.buyFirstForm.months = 10000;
      }
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAuthData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getAuthData();
      }
    },
    resetVerifyCodeResult() {
      this.verifyCodeResult.success = false;
      this.verifyCodeResult.loading = false;
      this.verifyCodeResult.icon = '';
    },
    verifyCodeOnInput(val) {
      if (val) {
        this.verifyCodeResult.success = false;
        this.verifyCodeResult.loading = true;
        this.verifyCodeResult.icon = 'el-icon-loading';
        verifyCode({ code: val, product: 1 })
          .then(() => {
            this.verifyCodeResult.success = true;
            this.verifyCodeResult.loading = false;
            this.verifyCodeResult.icon = 'el-icon-success';
          })
          .catch(() => {
            this.verifyCodeResult.icon = 'el-icon-error';
            this.verifyCodeResult.success = false;
            this.verifyCodeResult.loading = false;
          });
      } else {
        this.verifyCodeResult.icon = '';
        this.verifyCodeResult.success = false;
        this.verifyCodeResult.loading = false;
      }
    },
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    search() {
      this.restPage(true);
      let params = {
        date_start: this.searchOption.openingDateStart,
        date_stop: this.searchOption.openingDateEnd,
        expire_start: this.searchOption.expirationDateStart,
        expire_stop: this.searchOption.expirationDateEnd,
        name: this.searchOption.customerName,
        code: this.searchOption.code,
        edition: 201,
        username: this.searchOption.username,
      };
      let result = createGetUrlParams(params);

      if (result.success) {
        this.loading = true;
        getXZAuthList(result.data)
          .then((response) => {
            this.tableData = this.createTableData(response.results);
            this.pagination.total = response.count;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = '';
        }
      }
      this.restPage(true);
      this.getAuthData();
    },
    createTableData(data){
      for (const d of data) {
        d.modules_name = ["小智API-标准"]
        d.modules.forEach(item => {
          d.modules_name.push(this.n_module[item])
        }); 
        d.modules_name = d.modules_name.join(",")
      }
      console.log(data)
      return data
    },
    getAuthData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        edition: 201,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getXZAuthList(result.data)
          .then((response) => {
            // console.log(response);
            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = this.createTableData(response.results);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getAuthStatus(index) {
      return authStatus[index];
    },
    triallDialogOpen() {
      this.$refs.buyApiDialog.isAdd = 'triall';
      this.$refs.buyApiDialog.show();
    },
    triallFormSubmit() {
      //申请试用
      this.$refs.triallForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.triallForm.product = 1; //FastBI
          addTrail(this.triallForm)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.getAuthData();
              this.triallDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restTriallForm(done) {
      if (this.$refs.triallForm) this.$refs.triallForm.resetFields();
      done();
    },
    addPointOpen(index, row) {
      //加点
      this.payTableShow = false;
      this.curentId = row.id;
      this.addPointForm.code = row.code;
      this.addPointForm.key = row.key;
      this.addPointForm.name = row.name;
      this.addPointForm.old_user_count = row.user_count;
      this.addPointDialog = true;
    },
    addPointSubmit() {
      this.$refs.addPointForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            user_count: this.addPointForm.user_count,
            pay_type: this.addPointForm.pay_type,
          };
          addUserPrice(this.curentId, data)
            .then((response) => {
              //获取此次充值的价格
              response.code = this.addPointForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  this.loading = false;
                  let finance = {
                    special: this.$store.getters.userInfo.finance.xz_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.addPointForm.pay_type,
                  };
                  let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    addPointPay() {
      this.loading = true;
      addUser(this.curentId, this.payData)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.addPointDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restAddPointForm(done) {
      //重置修改密码表单
      if (this.$refs.addPointForm) this.$refs.addPointForm.resetFields();
      done();
    },
    renewOrBuy(index, row) {
      this.$refs.buyApiDialog.isAdd = 'edit';
      this.$refs.buyApiDialog.show(row);
    },
    addmoduleOpen(index, row) {
      this.$refs.addApiProduct.isAdd = 'module';
      this.$refs.addApiProduct.show(row);
    },
    addUserOpen(index, row) {
      this.$refs.addApiProduct.isAdd = 'user';
      this.$refs.addApiProduct.show(row);
    },
    isMaintainer() {
      // return false
      if (this.$store.getters.userInfo) {
        if (this.$store.getters.userInfo.is_superuser) return true
        return this.$store.getters.userInfo.is_maintainer
      }
      return false
    },
    renewOpen(index, row) {
      //续费
      console.log(row);
      this.currentEdition = row.edition;
      if (
        this.currentEdition == 'FastBI企业版' ||
        this.currentEdition == 'FastBI高级版' ||
        this.currentEdition == 'FastBI基础版'
      ) {
        this.renewForm.months = 10000;
      }
      this.payTableShow = false;
      this.curentId = row.id;
      this.renewForm.code = row.code;
      this.renewForm.name = row.name;
      this.renewForm.old_user_count = row.user_count;
      this.renewForm.old_expire_time = row.expire_time;
      this.getExpireTime(this.renewForm.months);
      this.renewDialog = true;
    },
    // 计算续费后截止日期
    getExpireTime(value) {
      console.log(value);
      if (this.buyDateDict[value] === '买断') {
        this.renewForm.buy_expire_time = '买断';
        return;
      }
      let dateArr = this.renewForm.old_expire_time.split('-');
      dateArr[0] = Number(dateArr[0]) + this.buyDateDict[value];
      this.renewForm.buy_expire_time = dateArr.join('-');
    },
    isShowDelayBtn(index, row) {
      return new Date(row.expire_time) <= new Date(); //过期时间小于当前时间
    },
    delayClick(index, row) {
      //试用延期
      let self = this;
      this.$confirm('您将对授权码进行延期操作，是否继续进行？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.loading = true;
          trialXZDelay(row.id)
            .then((response) => {
              self.loading = false;
              self.$message.success('延期成功!');
              self.getAuthData();
            })
            .catch(() => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    renewSubmit() {
      this.$refs.renewForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            months: this.renewForm.months,
            pay_type: this.renewForm.pay_type,
          };
          addMonthPrice(this.curentId, data)
            .then((response) => {
              response.code = this.renewForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  let finance = {
                    special: this.$store.getters.userInfo.finance.xz_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.renewForm.pay_type,
                  };
                  let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                  this.loading = false;
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    renewPay() {
      this.loading = true;
      addMonth(this.curentId, this.payData)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.renewDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restRenewForm(done) {
      if (this.$refs.renewForm) this.$refs.renewForm.resetFields();
      done();
    },
    changeKeyOpen(index, row) {
      //修改密码
      this.curentId = row.id;
      this.currentIndex = index;
      this.changKeyForm.code = row.code;
      this.changeKeyDialog = true;
    },
    changeKeySubmit() {
      this.$refs.changKeyForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            key: this.changKeyForm.newPassword,
          };
          updateAuth(this.curentId, data)
            .then((response) => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '修改密码成功',
              });
              this.getAuthData();
              this.changeKeyDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restChangeKeyForm(done) {
      //重置修改密码表单
      if (this.$refs.changKeyForm) this.$refs.changKeyForm.resetFields();
      done();
    },
    editCustomerOpen(index, row) {
      //编辑信息
      this.curentId = row.id;
      this.currentIndex = index;
      this.editCustomerForm.name = row.name;
      this.editCustomerForm.contact_name = row.contact_name;
      this.editCustomerForm.phone = row.phone;
      this.editCustomerForm.email = row.email;
      this.editCustomerDialog = true;
    },
    editCustomerSubmit() {
      this.$refs.editCustomerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          updateXZAuth(this.curentId, this.editCustomerForm)
            .then((response) => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '更新客户信息成功',
              });
              this.tableData[this.currentIndex].name = response.name;
              this.tableData[this.currentIndex].contact_name = response.contact_name;
              this.tableData[this.currentIndex].phone = response.phone;
              this.tableData[this.currentIndex].email = response.email;
              //this.tableData[this.currentIndex] = response
              this.editCustomerDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restEditCustomerForm(done) {
      if (this.$refs.editCustomerForm) this.$refs.editCustomerForm.resetFields();
      done();
    },
    certificateOpen(index, row) {
      //显示授权证书
      this.certificateUrl = '';
      this.certi_attach_url = '';
      this.loading = true;
      getCertificateById(row.id)
        .then((response) => {
          this.certificateUrl = response.url;
          this.certi_attach_url = response.attach_url;
          this.loading = false;
          this.certificateDialog = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    offlineAuthOpen(index, row) {
      this.offlineForm.auth_code = row.code;
      this.offlineForm.code = '';
      console.log(row);
      this.offlineDialog = true;
    },
    offlineAuthClose() {
      // this.offlineForm = {
      //   code: "",
      //   auth_code: "",
      // };
      this.offlineDialog = false;
    },
    // 申请授权
    applyOffline() {
      this.$confirm(
        `您要进行离线授权的授权码是${this.offlineForm.auth_code
        }，离线授权成功后，该授权码将不再可以进行在线验证，确定进行离线授权么？?`,
        '离线授权',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          setOffline(this.offlineForm)
            .then((res) => {
              console.log(res);
              // this.offlineDialog = true;
              this.offlineAuthClose();

              location.href = res.url;
            })
            .catch((err) => { });
        })
        .catch(() => { });
    },
    buyFirstDialogOpen() {
      this.$refs.buyApiDialog.isAdd = 'add';
      this.$refs.buyApiDialog.show();
      //申请购买
      //   this.payTableShow = false;
      //   this.resetVerifyCodeResult();
      //   if (this.buyFirstForm.edition == 11) {
      //     this.buyFirstForm.months = 12;
      //     this.buyFirstForm.user_count = 1;
      //   } else {
      //     this.buyFirstForm.months = 10000;
      //     this.buyFirstForm.user_count = 100;
      //   }
      //   //this.buyFirstForm.edition = '11'
      //   this.buyFirstDialog = true;
    },
    buyFirstSubmit() {
      this.$refs.buyFirstForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.buyFirstForm.product = 1; //fastbi
          let data = {
            user_count: this.buyFirstForm.user_count,
            months: this.buyFirstForm.months,
            pay_type: this.buyFirstForm.pay_type,
            product: 1,
            edition: this.buyFirstForm.edition,
          };
          buyPrice(data)
            .then((response) => {
              //获取此次充值的价格
              response.code = this.buyFirstForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  this.loading = false;
                  let finance = {
                    special: this.$store.getters.userInfo.finance.xz_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.buyFirstForm.pay_type,
                  };
                  let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    firstBuySure() {
      this.loading = true;
      buy(this.buyFirstForm)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.buyFirstDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restbuyFirstForm(done) {
      if (this.$refs.buyFirstForm) this.$refs.buyFirstForm.resetFields();
      done();
    },
    cancel(formName, close) {
      this.$refs[formName].resetFields();
    },
    parseDate(date) {
      const tempDate = new Date(date);
      if (isNaN(tempDate.getTime())) {
        const year = tempDate.getFullYear();
        if (year >= 2100) return '买断';
        return date;
      }
      return date;
    },
    upgradeHanlde(index, row) {
      const upgradeDialog = this.$refs.upgradeDialog;
      const data = { data: row, XZEditions: this.XZEditions };
      upgradeDialog.setFormData(data);
      upgradeDialog.show();
    },
    async initXZEditions() {
      try {
        let res = await getXZEditions();
        if (res.length) this.XZEditions = res;
      } catch (error) {
        console.warn(error);
      }
    },
  },
  components: {
    buyApiDialog,
    upgradeDialog,
    transferDialog,
    extensionDialog,
    addApiProduct
  },
};
</script>

<style lang="scss">
@import url('../../assets/css/product.css');

.xz_products {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector {
      background: #fff;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }
  }

  .alert {
    margin-bottom: 10px;
  }

  .pay_btn {
    float: right;
  }
}

.certificate_img_main {
  display: flex;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/xzReport/xzApiProduct.vue